import { useCallback } from "react";
import { ThemeProvider, useTheme } from "@/context/ThemeProvider";
import { ModeProvider, MODE_CONFIG } from "@/lib/ModeContext";
import { TimerProvider } from "@/lib/TimerContext";
import { AuthProvider } from "@/lib/AuthContext";
import { SubscriptionProvider } from "@/lib/SubscriptionContext";
import { UsageProvider } from "@/lib/UsageContext";
import { FeatureFlagProvider } from "@/lib/FeatureFlagContext";
import { TooltipProvider } from "@/components/ui/tooltip";
import ThemeSyncer from "@/components/ThemeSyncer";

function InnerProviders({ children }) {
  const { setTheme, activeThemeId, allThemes } = useTheme();

  const handleModeChange = useCallback((newMode) => {
    const cfg = MODE_CONFIG[newMode];
    if (!cfg) return;
    const current = allThemes.find((t) => t.id === activeThemeId);
    if (current?.styleType !== cfg.styleType) {
      setTheme(cfg.defaultTheme);
    }
  }, [setTheme, activeThemeId, allThemes]);

  return (
    <ModeProvider onModeChange={handleModeChange}>
      <SubscriptionProvider>
        <UsageProvider>
          <TooltipProvider delayDuration={400} skipDelayDuration={200}>
            <TimerProvider>
              <ThemeSyncer />
              {children}
            </TimerProvider>
          </TooltipProvider>
        </UsageProvider>
      </SubscriptionProvider>
    </ModeProvider>
  );
}

export default function Providers({ children }) {
  return (
    <ThemeProvider>
      <AuthProvider>
        <FeatureFlagProvider>
          <InnerProviders>
            {children}
          </InnerProviders>
        </FeatureFlagProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
